/**
 * Test-only bridge for Playwright (production builds omit behavior via dead-code paths).
 * Enable with REACT_APP_E2E=true at build time.
 */

export function isE2E() {
  return process.env.REACT_APP_E2E === 'true';
}

export function resetE2eBridge() {
  if (!isE2E() || typeof window === 'undefined') return;
  window.__LETTER_QUEST_E2E__ = { calls: [] };
}

/** @param {string} kind @param {Record<string, unknown>} payload */
export function e2eAppendCall(kind, payload) {
  if (!isE2E() || typeof window === 'undefined') return;
  const root = window.__LETTER_QUEST_E2E__ || { calls: [] };
  if (!root.calls) root.calls = [];
  root.calls.push({ kind, payload, t: Date.now() });
  window.__LETTER_QUEST_E2E__ = root;
}

/** @param {Record<string, unknown>} crosswordDebug */
export function e2eSetCrossword(crosswordDebug) {
  if (!isE2E() || typeof window === 'undefined') return;
  const root = window.__LETTER_QUEST_E2E__ || { calls: [] };
  root.crossword = crosswordDebug;
  window.__LETTER_QUEST_E2E__ = root;
}
